import { render, staticRenderFns } from "./WEBPOPLIST.vue?vue&type=template&id=e2661930"
import script from "./WEBPOPLIST.vue?vue&type=script&lang=js"
export * from "./WEBPOPLIST.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports